module.exports = __webpack_public_path__ + "static/media/plus-octagon.c61f13f3.svg";